/*
 *  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  * No part of this publication may be reproduced, distributed,
 *  * or transmitted in any form or by any means, including photocopying, recording,
 *  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  * except in the case of brief quotations embodied in critical
 *  * reviews and certain other noncommercial uses permitted by copyright law.
 *  *  author : BS
 *  *  date : 4/28/23, 2:54 PM
 */

import { SelectableEntity } from './entity/selectable-entity';
import { StandardAction } from '../tool/action/standard-action';
import { CommonUtils } from '../tool/common-utils';

export class SortableList<T extends SelectableEntity> {
  public id: string;
  public title: string;
  public draggingItem: T;
  public icon: string;
  public actions: StandardAction[] = [];
  public borderColor = CommonUtils.color('grey-c8');

  public minWidth = '250px';
  public maxWidth = '';

  public disabled = false;
  public visible = true;

  public index: number;

  constructor(id: string, title: string, items: T[]) {
    this.id = id;
    this.title = title;
    this._items = items.slice();
  }

  protected _items: T[] = [];

  public get items(): T[] {
    return this._items;
  }

  public set items(items: T[]) {
    this._items = items.slice();
  }

  public move(item: T, index: number): void {
    this._items.splice(this._items.indexOf(item), 1);
    this._items.splice(index, 0, item);
  }

  public remove(item: T): void {
    this._items.splice(this._items.indexOf(item), 1);
  }

  public add(item: T): void {
    this._items.push(item);
  }
}
